import { createAction } from '@/utility/actions';

import {
  USERS_GET_LIST,
  USERS_CLEAN_LIST,
  USERS_ADD_USER,
  USERS_UPDATE_USER,
  USERS_ACTIVATE_USER,
} from './_types.ts';

/**
 * Get Users list
 * @param {object} params
 */
export const getUsers = createAction(USERS_GET_LIST);

/**
 * Clean Users list
 * @param {object} params
 */
export const cleanUsersList = createAction(USERS_CLEAN_LIST);

/**
 * Add user
 * @param {object, function} data, callback
 */
export const addUser = createAction(USERS_ADD_USER);

/**
 * Update user
 * @param {number, object, function} user_id, data, callback
 */
export const updateUser = createAction(USERS_UPDATE_USER);

/**
 * Activate user
 * @param {number, object, function} user_id, data, callback
 */
export const activateUser = createAction(USERS_ACTIVATE_USER);

export default {
  getUsers,
  cleanUsersList,
  addUser,
  updateUser,
  activateUser,
};
